export default "__VITE_ASSET__BCe$igkg__"